import React from "react"
import PropTypes from "prop-types"
import {checkDate} from '../../../lib/timetable'

import './Reservation.Time.less'

export default class TimePicker extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { }
  }

  render() {
    const {timetable, onChange, date, value} = this.props
    const {times} = checkDate(timetable, date)
    return  (
      <div className="timesContainer" id="TimePicker">
        {times.map(hour => (
          <div
            key={hour}
            className={`hour ${hour == value ? "selected" : ""}`}
            onClick={() => {
              onChange(hour)
            }}
          >
            {hour}
          </div>))}
      </div>
    )
  }
}


TimePicker.propTypes = {
  timetable: PropTypes.object.isRequired,
  date: PropTypes.instanceOf(Date),
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/app/catalogo/reservation/Reservation.Time.jsx